export const emptyAuthResponse = {
    email: '',
    firstName: '',
    lastName: '',
    phone: '',
    refreshToken: '',
    token: '',
    _id: '',
};
